import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCalendar,
  faQrcode,
  faTrash,
  faUserPlus,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Vue from "vue";

library.add(faTrash, faCalendar, faQrcode, faUserPlus, faSignOutAlt);

Vue.component("font-awesome-icon", FontAwesomeIcon);
